import type { MfaChallengeState } from 'containers/MfaVerifyPage/types'

const STORAGE_KEY = 'mfaChallenge'

type StoredMfaChallenge = {
  mfaSessionId: string
  email: string
  // 絶対時刻 (ms) で持つことでブラウザリロード後も残秒数を正確に再計算できる
  expiresAt: number
}

const isStoredMfaChallenge = (value: unknown): value is StoredMfaChallenge =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as StoredMfaChallenge).mfaSessionId === 'string' &&
  typeof (value as StoredMfaChallenge).email === 'string' &&
  typeof (value as StoredMfaChallenge).expiresAt === 'number'

export const saveMfaChallenge = (challenge: MfaChallengeState): void => {
  if (!challenge.mfaSessionId) return
  const stored: StoredMfaChallenge = {
    mfaSessionId: challenge.mfaSessionId,
    email: challenge.email,
    expiresAt: Date.now() + challenge.expiresInSeconds * 1000,
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
  } catch {
    // sessionStorage が使えない環境では復元を諦める (リロード時 /login に戻るのみ)
  }
}

export const loadMfaChallenge = (): MfaChallengeState | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    if (!isStoredMfaChallenge(parsed)) {
      sessionStorage.removeItem(STORAGE_KEY)
      return null
    }
    const remainingMs = parsed.expiresAt - Date.now()
    if (remainingMs <= 0) {
      sessionStorage.removeItem(STORAGE_KEY)
      return null
    }
    return {
      mfaSessionId: parsed.mfaSessionId,
      email: parsed.email,
      expiresInSeconds: Math.ceil(remainingMs / 1000),
    }
  } catch {
    return null
  }
}

export const clearMfaChallenge = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // noop
  }
}
